/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import { Helmet } from "react-helmet-async";
import { gaSet } from "@/src/services/googleAnalyticsService";

const HomePageMeta = () => {
  const title = "Recht leicht gemacht! | Legalbird";
  gaSet({ title: title });

  return (
    <Helmet>
      <title>{title}</title>
      <meta
        name="description"
        content="Wir helfen Ihnen einfach, schnell und professionell. Egal wann und wo!
      Onlinescheidung ohne Anwaltsbesuch einreichen. Abfindung sichern und Kündigungsschutzklage einreichen.
      Einspruch einlegen gegen Ordunungswidrigkeit. Professionell vom Fachanwalt beraten lassen!"
      />
      <meta
        name="keywords"
        content="Onlinescheidung, Scheidung online, Scheidung, Scheidung einreichen, online scheiden lassen, Scheidungskosten, einvernehmliche Scheidung"
      />
      <meta name="robots" content="index,follow" />
      <meta property="og:title" content={title} />
      <meta property="og:locale" content="de_DE" />
      <meta property="og:type" content="website" />
      <meta
        property="og:description"
        content="Wir helfen Ihnen einfach, schnell und professionell. Egal wann und wo!
      Onlinescheidung ohne Anwaltsbesuch einreichen. Abfindung sichern und Kündigungsschutzklage einreichen.
      Einspruch einlegen gegen Ordunungswidrigkeit. Professionell vom Fachanwalt beraten lassen!"
      />
    </Helmet>
  );
};

export default HomePageMeta;
